import notifee, { AndroidStyle, AndroidImportance } from '@notifee/react-native';
import { INotificationData } from './notificationData';
import {
  getTimerNotificationId,
  setTimerNotificationId,
  setActiveInterval,
  stopTimerNotification,
} from './notificationTimerManager';
export async function displayNotificationWithTimer({
  title,
  body,
  imageUrl,
  data,
}: {
  title: string;
  body: string;
  imageUrl?: string;
  data?: INotificationData;
}) {
  // Parse startTime and endTime from data (assume UNIX seconds)
  const startTime = data?.startTime ? Number(data.startTime) : undefined;
  const endTime = data?.endTime ? Number(data.endTime) : undefined;
  const showTimer = data?.showTimer === 'true';
  const now = Math.floor(Date.now() / 1000);

  // Only show progress if current time is within window
  const showProgress =
    showTimer &&
    typeof startTime === 'number' &&
    typeof endTime === 'number' &&
    now >= startTime &&
    now <= endTime;

  let totalDuration = 0;
  let remainingTime = 0;
  let elapsedTime = 0;
  if (showProgress) {
    totalDuration = endTime - startTime;
    remainingTime = endTime - now;
    elapsedTime = totalDuration - remainingTime;

    if (!getTimerNotificationId()) {
      setTimerNotificationId(`${data?.campaignId ?? 'generic'}-${Date.now()}`);
    }
  } else {
    setTimerNotificationId(null);
  }

  const notificationId =
    getTimerNotificationId() || `${data?.campaignId ?? 'generic'}-${Date.now()}`;

  stopTimerNotification(); // Stop any previous
  const fullBody = showProgress ? `${body}\n${formatTime(remainingTime)}` : body;

  const androidStyle =
    imageUrl && !showProgress
      ? { type: AndroidStyle.BIGPICTURE, picture: imageUrl }
      : { type: AndroidStyle.BIGTEXT, text: fullBody };

  const channel = await notifee.getChannel('default_timer');
  if (!channel) {
    await notifee.createChannel({
      id: 'default_timer',
      name: 'Ninja kisaan Generic',
    });
  }

  await notifee.displayNotification({
    id: data?.messageId ?? Date.now().toString(),
    title,
    body: fullBody,
    data: {
      id: data?.campaignId ?? '-1',
      path: data?.deeplinkingUrl ?? '/',
      sourceReferenceId: data?.sourceReferenceId ?? '-1',
      sourceReferenceType: data?.sourceReferenceType ?? '-1',
    },
    android: {
      channelId: 'default_timer',
      smallIcon: 'ic_notification',
      importance: AndroidImportance.HIGH,
      onlyAlertOnce: true,
      pressAction: {
        id: 'default',
        launchActivity: 'default',
      },
      ...(showProgress && {
        progress: {
          max: totalDuration,
          current: elapsedTime,
          indeterminate: false,
        },
        actions: [
          {
            title: 'Dismiss',
            pressAction: { id: 'DISMISS_ACTION' },
          },
        ],
      }),
      ...(imageUrl && { largeIcon: { uri: imageUrl } }),
      // style: {

      // },
    },
  });

  // Only start the timer loop if showProgress is true
  if (!showProgress) return;

  const interval = setInterval(async () => {
    remainingTime--;
    if (remainingTime < 0) {
      stopTimerNotification();
      return;
    }

    const updatedElapsed = totalDuration - remainingTime;
    const updatedBody = `${body}\n${formatTime(remainingTime)}`;

    await notifee.displayNotification({
      id: notificationId,
      title,
      body: updatedBody,
      android: {
        channelId: 'default',
        smallIcon: 'ic_notification',
        importance: AndroidImportance.HIGH,
        onlyAlertOnce: true,
        progress: {
          max: totalDuration,
          current: updatedElapsed,
          indeterminate: false,
        },
        actions: [
          {
            title: 'Dismiss',
            pressAction: { id: 'DISMISS_ACTION' },
          },
        ],
        ...(imageUrl && { largeIcon: { uri: imageUrl } }),
        style: {
          type: AndroidStyle.BIGTEXT,
          text: updatedBody,
        },
      },
    });
  }, 1000);

  setActiveInterval(interval);
}

export async function displayNotification({
  title,
  body,
  imageUrl,
  data,
}: {
  title: string;
  body: string;
  imageUrl?: string;
  data?: INotificationData;
}) {
  const channel = await notifee.getChannel('default');
  if (!channel) {
    await notifee.createChannel({
      id: 'default',
      name: 'Ninja kisaan Generic',
    });
  }

  // const id = Date.now().toString()
  console.log("Notifee display => ", data?.messageId);

  await notifee.displayNotification({
    // id: data?.messageId,
    title,
    body,
    data: {
      id: data?.campaignId ?? '-1',
      path: data?.deeplinkingUrl ?? '/',
      sourceReferenceId: data?.sourceReferenceId ?? '-1',
      sourceReferenceType: data?.sourceReferenceType ?? '-1',
    },
    android: {
      channelId: 'default',
      smallIcon: 'ic_notification',
      importance: AndroidImportance.LOW,
      onlyAlertOnce: true,
      pressAction: {
        id: 'default',
        launchActivity: 'default',
      },
      ...(imageUrl && { largeIcon: { uri: imageUrl } }),
      ...(imageUrl && { style: { type: AndroidStyle.BIGPICTURE, picture: imageUrl } }),
    },
  });
}

// Helper function to convert seconds → mm:ss
function formatTime(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
